<script setup>
import { computed, onMounted, ref, nextTick, watch, defineEmits } from 'vue';
import TmsTable from '../table/TmsTable.vue';
import { xios } from '../forms/tempAxios';

const emit = defineEmits(['update:selected']);

const columnsType = [
  {
    name: 'referenceNumber',
    field: 'referenceNumber',
    label: 'Reference #',
    align: 'left',
    sortable: true
  },
  {
    name: 'customerName',
    field: row => (row.Customer && row.Customer.companyName) || 'N/A',
    label: 'Customer',
    sortable: true
  },
  {
    name: 'bookingType',
    field: 'bookingType',
    label: 'Type',
    sortable: true
  },
  {
    name: 'tripCount',
    field: row => row.trips ? row.trips.length : 0,
    label: 'Trips',
    align: 'center',
    sortable: true
  },
  {
    name: 'status',
    field: 'status',
    label: 'Status',
    align: 'center',
    sortable: true
  }
];

const columns = computed(() => {
  let arr = [];
  columnsType.forEach((e) => {
    if (!e.hidden) {
      e.align = e.align || 'left';
      arr.push(e);
    }
  });
  return arr;
});

const data = ref([]);
const filter = ref('Unassigned');

// Watch for filter changes
watch(filter, () => {
  console.log(`Filter changed to: ${filter.value}`);
  fetchData(); // Refetch when filter changes
});

onMounted(async () => {
  await nextTick();
  await fetchData();
  console.log('Booking data loaded', data.value);
});

async function fetchData() {
  try {
    // Determine the status filter based on the 'filter' ref
    let tripWhere = {};
    
    if (filter.value === 'Unassigned') {
      tripWhere.value = 'unassigned';
      tripWhere.field = 'status'
      tripWhere.operator = 'eq'
    } else {
      // For 'Assigned', we need all non-unassigned bookings
      // This would require a more complex query, or you might need to adjust your backend
   
      tripWhere.value = 'unassigned';
      tripWhere.field = 'status'
      tripWhere.operator = 'ne'
    }
    
    const res = await xios.post('api-tms/script-pagination-standard', {
      model: 'Booking',
      page: 1,
      itemsPerPage: 10,
      attributesInclude: [],
      includeModels: [
        {
          model: 'Trip',
          filterFields: [tripWhere],
          required: true,
        },
        {
          model: 'Customer'
        }
      ],
      orderBy: 'DESC',
      filterFields: [
        {
          field: 'clientId',
          operator: 'eq',
          value: JSON.parse(localStorage.getItem('userInfo')).uid,
        },
      ],
    });
    
    if (res.data.success) {
      data.value = res.data.data.items.map(item => ({ 
        ...item, 
        customerName: (item.Customer && item.Customer.companyName) || 'N/A' 
      }));
    } else {
      console.error('Failed to fetch booking data:', res.data);
      data.value = [];
    }
  } catch (error) {
    console.error('Error fetching booking data:', error);
    data.value = [];
  }
}

// Add booking edit and navigation functions
function editBooking(bookingData) {
  if (!bookingData || !bookingData.id) {
    console.error('Invalid booking data passed to editBooking:', bookingData);
    return;
  }
  console.log(`Editing booking with ID: ${bookingData.id}`);
  localStorage.setItem('currentBookingId', bookingData.id);
  emit('update:selected', 'Create Booking');
}


</script>

<template>
  <div class="fit">
    
    <TmsTable 
      :data="data" 
      :selected="$attrs.selected" 
      :columns="columns"
      row-key="id"
      @edit-row="editBooking"
    />
  </div>
</template>
